const resources = {
    getStarted: 'Get Started',
    signInToGetStarted: 'Sign In to Get Started'
};

module.exports = function getResource(label) {
    return resources[label];
};
